<template>
  <div class="pa-select" v-click-outside="close">
    <select hidden v-model="selectedValue" :name="selectName" :required="required">
      <option
        v-for="(option, index) in options"
        :key="`option-${index}`"
        :value="optionKey ? option[optionKey] : option"
        >{{ customLabel ? option[customLabel] : option }}</option
      >
    </select>
    <div class="pa-select__container" :class="{ open: isOpen }">
      <div
        class="pa-select__label truncate"
        :class="selectClasses"
        tabindex="-1"
        @click="selectClicked()"
      >
        <slot name="option" :data="selectedOption" v-if="selectedValue">
          <div v-if="searchable">
            <input
              type="text"
              v-model="query"
              ref="input"
              aria-label="search"
              class="pa-search-input"
              :placeholder="customLabel ? selectedValue[customLabel] : selectedValue"
            />
          </div>
          <div v-else>
            {{
              customLabel || optionKey ? selectedOption[customLabel || optionKey] : selectedValue
            }}
          </div>
        </slot>
        <template v-else>
          <div v-if="searchable">
            <input
              ref="input"
              class="pa-search-input"
              v-model="query"
              aria-label="search"
              :placeholder="placeholder"
              type="text"
            />
            <!-- <text-input></text-input> -->
          </div>
          <div v-else>
            {{ placeholder }}
          </div>
        </template>
        <slot name="icon">
          <i class="icon-caret-down ml-auto"></i>
        </slot>
      </div>

      <div class="pa-select__options">
        <div class="pa-select__option" v-if="!required" @click.prevent="selectOption(null)">
          Select an option
        </div>

        <div
          class="pa-select__option"
          :class="
            `${
              (selectedValue && optionKey && selectedOption[optionKey] === option[optionKey]) ||
              selectedValue === option
                ? 'active'
                : ''
            } ${optionClasses}`
          "
          tabindex="0"
          v-for="(option, index) in filteredOptions"
          :key="index"
          @click.prevent="selectOption(option)"
        >
                  <slot name="option" :data="option">
            {{ customLabel ? option[customLabel] : option }}
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
/* eslint-disable space-before-function-paren */
// import { TextInput } from '../text-input/TextInput.vue';

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    searchable: {
      type: Boolean,
      required: false,
    },
    optionKey: {
      type: String,
    },
    customLabel: {
      type: String,
    },
    searchHandler: {
      type: Function,
    },
    placeholder: {
      type: String,
      default: 'Select an option',
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    selectClasses: {
      type: String,
      default: '',
    },
    optionClasses: {
      type: String,
      default: '',
    },
    initialValue: {
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectName: {
      type: String,
      default: '',
    },
  },
  directives: {
    'click-outside': {
      bind: function(el, binding, vnode) {
        // eslint-disable-next-line no-param-reassign
        el.clickOutsideEvent = function(event) {
          // here I check that click was outside the el and his childrens
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  computed: {
    filteredOptions() {
      /**
       * This function filters the list of options gotten as a prop
       * based on the Input Query  in the input search Field
       * @function filteredOptions
       * @param {Array} option
       * @param {query} query - This is the search Field
       * @return {Array} - Returns a Filtered List of Options
       */
      function filterOption(option, query, label) {
        return label
          ? option[label].toLowerCase().includes(query.toLowerCase())
          : option.toLowerCase().includes(query.toLowerCase());
      }
      if (!this.searchable) {
        return this.options;
      }
      return this.options.filter(
        this.searchHandler
          ? this.searchHandler
          : option => filterOption(option, this.query, this.customLabel),
      );
    },
  },
  data() {
    return {
      isOpen: false,
      hide: true,
      query: '',
      selectedValue: this.initialValue,
      selectedOption: this.initialValue,
    };
  },
  methods: {
    /**
     * Called when an option is selected and emits input back to parent component
     * @function selectOption
     * @param {Array} option
     * @return {void}
     */
    selectOption(option) {
      this.selectedOption = option;
      const value = this.optionKey ? option[this.optionKey] : option;
      this.selectedValue = value;
      this.query = this.customLabel ? option[this.customLabel] : option;
      this.$emit('input', value);

      if (this.closeOnSelect) {
        this.close();
      }
    },
    /**
     * This Closes the list of options
     * @function close
     * @return {void}
     */
    close() {
      this.isOpen = false;
      if (this.searchable) this.$refs.input.blur();
    },
    /**
     * Opens list of options adds Focus to Seach Input when select option dropdown is clicked
     * @function selectClicked
     * @return {void}
     */
    selectClicked() {
      this.isOpen = !this.isOpen;
      if (this.searchable) this.$refs.input.focus();
    },
  },
};
</script>
<style lang="scss" scoped>
@import './dropdown-select.scss';
.pa-search-input {
  box-shadow: none;
  padding: 10px;
  border: none;
  outline: none;
}
</style>
